<template>
  <div
    class="ta-condition-report-images"
    v-if="images.carousel.length > 0"
  >
    <carousel :images="images.carousel" />
    <GallerySlideshow2 :images="images.gallery" :index="gallery_idx" />
  </div>
  <div
    v-else
    class="ta-condition-report-images"
  >
    <img
      class="d-block img-fluid mx-auto"
      src="https://cdn.artisio.co/no_image.jpg"
    />
  </div>
</template>

<script>
import Carousel from "@/components/Carousel.vue";
import {mapState} from "vuex";
import GallerySlideshow2 from "@/plugins/vue-gallery-slideshow/GallerySlideshow2.vue";

export default {
  name: "ConditionReportImages",
  components: {GallerySlideshow2, Carousel},
  props: {
    reportImages: Array,
  },
  data: () => ({
    gallery_idx: null
  }),
  computed: {
    ...mapState({
      lot: state => state.lotObject.data
    }),
    images() {
      let carousel = [];
      let gallery = [];

      let id = 0;
      for (const image of this.reportImages) {
        carousel.push({
          id: ++id,
          original: image,
          big: image,
          small: image,
          thumb: image,
        });
        gallery.push(image.url);
      }

      return {
        carousel,
        gallery
      };
    },
  },
}
</script>
